<template>
  <div class="home">
    <!-- ================= Hero ================= -->
    <section class="hero">
      <div class="wrap hero-grid">
        <div class="hero-copy">
          <span class="eyebrow-pill">
            <i></i> 苏屠粉丝专属 · 已服务 {{ site.stats[1].value }} 位粉丝
          </span>
          <h1>
            <span class="grad-text">{{ site.name }}</span>
            <br />
            回馈新老<span class="ink">粉丝福利</span>
          </h1>
          <p class="lead">{{ site.slogan }}</p>
          <p class="sub">{{ site.desc }}</p>
          <div class="cta">
            <router-link class="btn btn-primary" :to="`/task/${categories[0].key}`">
              立即开始赚米 →
            </router-link>
            <a class="btn btn-ghost" href="#upcoming">看看还有哪些业务</a>
          </div>
          <ul class="trust">
            <li>0 押金 · 0 门槛</li>
            <li>任务 5 分钟到账</li>
            <li>当日可提现</li>
          </ul>
        </div>

        <div class="hero-card panel">
          <div class="hc-top">
            <span class="hc-title">今日收益面板</span>
            <span class="hc-live"><i></i>实时</span>
          </div>
          <div class="hc-amount mono">¥{{ todayEstimate.toFixed(2) }}</div>
          <p class="hc-note">完成 {{ planCount }} 个任务 · 平均日赚 10 - 20 元</p>

          <ul class="hc-list">
            <li v-for="(t, i) in previewTasks" :key="i">
              <span class="hc-dot" :style="{ background: t.color }"></span>
              <span class="hc-name">{{ t.name }}</span>
              <span class="hc-val mono">+¥{{ t.reward.toFixed(2) }}</span>
            </li>
          </ul>

          <router-link class="hc-more" :to="`/task/${categories[0].key}`">
            任务持续上新，进来挑一个赚米的 →
          </router-link>
        </div>
      </div>

      <div class="wrap">
        <div class="stat-strip panel">
          <div v-for="s in site.stats" :key="s.label" class="stat">
            <span class="stat-val mono">{{ s.value }}<i>{{ s.unit }}</i></span>
            <span class="stat-label">{{ s.label }}</span>
          </div>
        </div>
      </div>
    </section>

    <!-- ================= 任务分类 ================= -->
    <section class="section" id="tasks">
      <div class="wrap">
        <div class="section-head">
          <span class="eyebrow">EARN TASKS</span>
          <h2>三大赚米任务，总有一款适合你</h2>
          <p>挑一个分类进去，几分钟就能完成一单，做完即结算</p>
        </div>

        <div class="grid">
          <router-link
            v-for="c in categories"
            :key="c.key"
            :to="`/task/${c.key}`"
            class="cat panel"
            :style="{ '--accent': c.accent }"
          >
            <div class="cat-top">
              <span class="cat-emoji">{{ c.emoji }}</span>
              <span class="tag">{{ c.badge }}</span>
            </div>
            <h3>{{ c.name }}</h3>
            <p class="cat-short">{{ c.short }}</p>
            <div class="cat-meta">
              <span><b class="mono">{{ c.tasks.length }}</b> 个任务</span>
              <span>日赚 <b class="mono grad-text">{{ c.dailyEarn }}</b> 元</span>
            </div>
            <span class="cat-go">进入任务 →</span>
            <span class="cat-glow"></span>
          </router-link>

          <!-- 其它业务 -->
          <a class="soon-banner panel" href="#upcoming">
            <span class="sb-emoji">🎁</span>
            <div class="sb-body">
              <div class="sb-title">
                <h3>其它挣米业务</h3>
                <span class="tag">陆续更新</span>
              </div>
              <p class="cat-short">带货分佣、游戏接单、直播间任务…更多赚钱玩法陆续上线</p>
            </div>
            <span class="sb-go">
              查看预告
              <i>→</i>
            </span>
          </a>
        </div>
      </div>
    </section>

    <!-- ================= 收益计算器 ================= -->
    <section class="section calc-wrap">
      <div class="wrap">
        <div class="calc panel">
          <div class="calc-info">
            <span class="eyebrow">收益估算</span>
            <h2>算算你一天能赚多少</h2>
            <p class="muted">
              多数粉丝每天做 3 - 6 个任务，收益普遍落在 <b class="grad-text">10 - 20 元</b>。
              拖动下面的滑杆，看看你自己的预期收益。
            </p>
            <div class="calc-split">
              <div>
                <span class="calc-num mono">¥{{ dailyEarn.toFixed(2) }}</span>
                <span class="muted">预计日收益</span>
              </div>
              <div>
                <span class="calc-num mono">¥{{ monthlyEarn.toFixed(0) }}</span>
                <span class="muted">预计月收益</span>
              </div>
            </div>
          </div>

          <div class="calc-controls">
            <label class="ctrl">
              <span class="ctrl-head">
                <span>每天完成任务数</span>
                <b class="mono">{{ planCount }} 个</b>
              </span>
              <input type="range" min="1" max="10" step="1" v-model.number="planCount" />
            </label>
            <label class="ctrl">
              <span class="ctrl-head">
                <span>平均单任务单价</span>
                <b class="mono">¥{{ avgPrice.toFixed(1) }}</b>
              </span>
              <input type="range" min="0.8" max="5" step="0.2" v-model.number="avgPrice" />
            </label>
            <div class="calc-scale">
              <span>0.8 元</span>
              <span>5 元 / 单</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ================= 参与流程 ================= -->
    <section class="section" id="flow">
      <div class="wrap">
        <div class="section-head">
          <span class="eyebrow">HOW TO START</span>
          <h2>四步走，轻松领福利</h2>
          <p>不收费、不押证，认准苏屠官方福利站</p>
        </div>
        <ol class="flow">
          <li v-for="s in steps" :key="s.n" class="flow-item panel">
            <span class="flow-n mono">{{ s.n }}</span>
            <h3>{{ s.title }}</h3>
            <p class="muted">{{ s.desc }}</p>
          </li>
        </ol>
      </div>
    </section>

    <!-- ================= 粉丝晒单 ================= -->
    <section class="section">
      <div class="wrap">
        <div class="section-head">
          <span class="eyebrow">FANS FEEDBACK</span>
          <h2>他们今天已经赚到啦</h2>
          <p>真实粉丝晒单（演示数据）</p>
        </div>
        <div class="quotes">
          <figure v-for="(t, i) in testimonials" :key="i" class="quote panel">
            <div class="quote-head">
              <span class="avatar">{{ t.name.slice(-2) }}</span>
              <div>
                <b>{{ t.name }}</b>
                <span class="muted">今日收益 +¥{{ t.earn }}</span>
              </div>
            </div>
            <blockquote>{{ t.text }}</blockquote>
            <div class="stars">★★★★★</div>
          </figure>
        </div>
      </div>
    </section>

    <!-- ================= 其它挣米业务 ================= -->
    <section class="section" id="upcoming">
      <div class="wrap">
        <div class="section-head">
          <span class="eyebrow">COMING SOON</span>
          <h2>其它挣米业务，陆续更新</h2>
          <p>新的赚钱玩法正在陆续上线，苏屠粉丝优先体验</p>
        </div>
        <ul class="soon">
          <li v-for="(u, i) in upcoming" :key="i" class="soon-item panel">
            <div class="soon-main">
              <h3>{{ u.name }}</h3>
              <p class="muted">{{ u.note }}</p>
            </div>
            <span class="soon-eta">{{ u.eta }}</span>
          </li>
        </ul>
      </div>
    </section>

    <!-- ================= FAQ ================= -->
    <section class="section" id="faq">
      <div class="wrap narrow">
        <div class="section-head">
          <span class="eyebrow">FAQ</span>
          <h2>常见问题</h2>
        </div>
        <ul class="faq">
          <li
            v-for="(f, i) in faqs"
            :key="i"
            class="faq-item panel"
            :class="{ open: openFaq === i }"
          >
            <button class="faq-q" @click="toggleFaq(i)">
              <span>{{ f.q }}</span>
              <i class="faq-icon"></i>
            </button>
            <div class="faq-a">
              <p class="muted">{{ f.a }}</p>
            </div>
          </li>
        </ul>
      </div>
    </section>

    <!-- ================= 底部 CTA ================= -->
    <section class="section">
      <div class="wrap">
        <div class="final-cta panel">
          <h2>今天还没开始赚？现在就来</h2>
          <p class="muted">挑一个任务分类，几分钟搞定第一单，先赚它 10 块。</p>
          <router-link class="btn btn-primary" :to="`/task/${categories[0].key}`">
            免费开始赚米 →
          </router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { site, categories, upcoming, steps, testimonials, faqs } from '@/data/site'

// 收益估算滑杆
const planCount = ref(4)
const avgPrice = ref(3)
const dailyEarn = computed(() => planCount.value * avgPrice.value)
const monthlyEarn = computed(() => dailyEarn.value * 30)

// Hero 面板的演示数据
const previewTasks = [
  { name: '小红书点赞+收藏', reward: 2.0, color: '#ff9e2c' },
  { name: '微信小程序签到', reward: 0.8, color: '#4ecb7a' },
  { name: '看直播领密钥', reward: 2.0, color: '#ff4d4d' },
  { name: '短视频文案编写', reward: 3.0, color: '#7f8cff' },
  { name: '应用下载注册', reward: 3.5, color: '#ffce5c' },
]
const todayEstimate = computed(() => previewTasks.reduce((s, t) => s + t.reward, 0))

// FAQ 手风琴
const openFaq = ref(0)
const toggleFaq = (i) => {
  openFaq.value = openFaq.value === i ? -1 : i
}
</script>

<style scoped>
/* ---------------- Hero ---------------- */
.hero {
  padding: 56px 0 24px;
}

.hero-grid {
  display: grid;
  grid-template-columns: 1.15fr 0.85fr;
  gap: 48px;
  align-items: center;
}

.eyebrow-pill {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  padding: 7px 16px;
  border-radius: 999px;
  font-size: 13px;
  color: var(--gold);
  background: rgba(255, 205, 120, 0.08);
  border: 1px solid var(--border);
}

.eyebrow-pill i {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--gold-2);
  animation: pulse 1.8s infinite;
}

h1 {
  margin: 22px 0 18px;
  font-size: clamp(34px, 5vw, 62px);
  line-height: 1.12;
  font-weight: 800;
  letter-spacing: 0.005em;
}

h1 .ink {
  color: var(--text);
}

.lead {
  font-size: clamp(18px, 2.2vw, 24px);
  font-weight: 700;
  color: var(--gold);
  letter-spacing: 0.04em;
  font-family: var(--font-display);
}

.sub {
  margin-top: 14px;
  max-width: 560px;
  color: var(--muted);
  font-size: 16px;
}

.cta {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  margin-top: 30px;
}

.trust {
  display: flex;
  flex-wrap: wrap;
  gap: 22px;
  margin-top: 26px;
  color: var(--muted-2);
  font-size: 14px;
}

.trust li {
  position: relative;
  padding-left: 20px;
}

.trust li::before {
  content: '✓';
  position: absolute;
  left: 0;
  color: #4ecb7a;
  font-weight: 700;
}

/* Hero 收益面板 */
.hero-card {
  padding: 28px 26px;
  box-shadow: var(--glow);
  position: relative;
  overflow: hidden;
}

.hc-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.hc-title {
  font-size: 14px;
  color: var(--muted);
}

.hc-live {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #4ecb7a;
}

.hc-live i {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #4ecb7a;
  animation: pulse 1.6s infinite;
}

.hc-amount {
  margin-top: 16px;
  font-size: 52px;
  font-weight: 700;
  line-height: 1;
  background: var(--grad-gold);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.hc-note {
  margin-top: 10px;
  font-size: 13.5px;
  color: var(--muted);
}

.hc-list {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.hc-list li {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 11px 0;
  border-bottom: 1px dashed rgba(255, 255, 255, 0.07);
  font-size: 14px;
}

.hc-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.hc-name {
  flex: 1;
  color: var(--text);
}

.hc-val {
  color: #4ecb7a;
  font-weight: 600;
}

.hc-more {
  display: inline-block;
  margin-top: 18px;
  font-size: 13.5px;
  color: var(--gold-2);
}

/* 数据条 */
.stat-strip {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  margin-top: 52px;
  padding: 26px 10px;
}

.stat {
  text-align: center;
  padding: 6px 14px;
  border-right: 1px solid var(--border);
}

.stat:last-child {
  border-right: none;
}

.stat-val {
  display: block;
  font-size: 30px;
  font-weight: 700;
  color: var(--text);
}

.stat-val i {
  font-size: 14px;
  font-style: normal;
  color: var(--muted);
  margin-left: 3px;
}

.stat-label {
  font-size: 13.5px;
  color: var(--muted);
}

/* ---------------- 通用区块 ---------------- */
.section {
  padding: 68px 0;
}

.narrow {
  max-width: 860px;
}

/* 分类网格 */
.grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 22px;
}

.cat {
  position: relative;
  display: block;
  padding: 28px 26px 26px;
  overflow: hidden;
  transition: transform 0.22s ease, border-color 0.22s ease;
}

.cat:hover {
  transform: translateY(-6px);
  border-color: var(--accent, var(--border-strong));
}

.cat-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
}

.cat-emoji {
  font-size: 34px;
  line-height: 1;
}

.cat h3 {
  font-size: 22px;
  font-weight: 800;
}

.cat-short {
  margin-top: 8px;
  color: var(--muted);
  font-size: 14.5px;
  min-height: 42px;
}

.cat-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 18px;
  padding-top: 16px;
  border-top: 1px dashed rgba(255, 255, 255, 0.08);
  font-size: 13.5px;
  color: var(--muted);
}

.cat-meta b {
  font-size: 16px;
}

.cat-go {
  display: inline-block;
  margin-top: 16px;
  font-weight: 600;
  color: var(--accent, var(--gold));
}

.cat-glow {
  position: absolute;
  right: -60px;
  top: -60px;
  width: 160px;
  height: 160px;
  border-radius: 50%;
  background: radial-gradient(circle, var(--accent, #ff9e2c), transparent 70%);
  opacity: 0.16;
  filter: blur(6px);
  transition: opacity 0.25s ease;
}

.cat:hover .cat-glow {
  opacity: 0.3;
}

/* 其它业务横幅 */
.soon-banner {
  grid-column: 1 / -1;
  display: flex;
  align-items: center;
  gap: 24px;
  padding: 24px 30px;
  border-style: dashed;
  transition: border-color 0.22s ease, transform 0.22s ease;
}

.soon-banner:hover {
  transform: translateY(-4px);
  border-color: var(--border-strong);
}

.sb-emoji {
  font-size: 40px;
  line-height: 1;
  flex-shrink: 0;
}

.sb-body {
  flex: 1;
  min-width: 0;
}

.sb-title {
  display: flex;
  align-items: center;
  gap: 12px;
}

.sb-title h3 {
  font-size: 21px;
  font-weight: 800;
}

.soon-banner .cat-short {
  min-height: 0;
  margin-top: 6px;
}

.sb-go {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  color: var(--gold);
  flex-shrink: 0;
}

.sb-go i {
  font-style: normal;
  transition: transform 0.22s ease;
}

.soon-banner:hover .sb-go i {
  transform: translateX(4px);
}

/* ---------------- 收益计算器 ---------------- */
.calc-wrap {
  padding-top: 20px;
}

.calc {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 46px;
  padding: 44px 46px;
  box-shadow: var(--glow);
}

.calc-info .eyebrow {
  color: var(--gold-2);
  font-size: 12.5px;
  letter-spacing: 0.3em;
}

.calc-info h2 {
  font-size: clamp(24px, 3vw, 34px);
  margin: 12px 0 14px;
  font-weight: 800;
}

.calc-info p {
  font-size: 15px;
}

.calc-split {
  display: flex;
  gap: 42px;
  margin-top: 30px;
}

.calc-split > div {
  display: flex;
  flex-direction: column;
}

.calc-num {
  font-size: 40px;
  font-weight: 700;
  line-height: 1.1;
  background: var(--grad-gold);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.calc-controls {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 30px;
}

.ctrl-head {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  font-size: 14px;
  color: var(--muted);
  margin-bottom: 14px;
}

.ctrl-head b {
  font-size: 20px;
  color: var(--text);
}

input[type='range'] {
  -webkit-appearance: none;
  appearance: none;
  width: 100%;
  height: 8px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.09);
  outline: none;
}

input[type='range']::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: var(--grad-gold);
  border: 3px solid #1c1712;
  box-shadow: 0 4px 14px rgba(255, 158, 44, 0.5);
  cursor: pointer;
}

input[type='range']::-moz-range-thumb {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #ff9e2c;
  border: 3px solid #1c1712;
  cursor: pointer;
}

.calc-scale {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: var(--muted-2);
}

/* ---------------- 流程 ---------------- */
.flow {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  counter-reset: step;
}

.flow-item {
  padding: 28px 24px;
  position: relative;
}

.flow-n {
  font-size: 40px;
  font-weight: 700;
  line-height: 1;
  color: transparent;
  -webkit-text-stroke: 1.4px var(--border-strong);
}

.flow-item h3 {
  margin: 16px 0 8px;
  font-size: 18px;
}

.flow-item p {
  font-size: 14px;
}

/* ---------------- 晒单 ---------------- */
.quotes {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.quote {
  padding: 26px 26px 22px;
}

.quote-head {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.avatar {
  display: grid;
  place-items: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  font-size: 14px;
  font-weight: 600;
  color: #241300;
  background: var(--grad-gold);
}

.quote-head b {
  display: block;
  font-size: 15px;
}

.quote-head span.muted {
  font-size: 12.5px;
}

blockquote {
  margin: 0;
  font-size: 15px;
  color: var(--text);
}

.stars {
  margin-top: 14px;
  color: var(--gold);
  letter-spacing: 3px;
  font-size: 14px;
}

/* ---------------- 其它业务 ---------------- */
.soon {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.soon-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 22px 24px;
}

.soon-main h3 {
  font-size: 17px;
}

.soon-main p {
  font-size: 13.5px;
  margin-top: 4px;
}

.soon-eta {
  flex-shrink: 0;
  padding: 5px 13px;
  border-radius: 999px;
  font-size: 12.5px;
  color: var(--gold);
  background: rgba(255, 205, 120, 0.1);
  border: 1px solid var(--border);
}

/* ---------------- FAQ ---------------- */
.faq {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.faq-item {
  overflow: hidden;
}

.faq-q {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 20px 24px;
  font-size: 16px;
  font-weight: 600;
  text-align: left;
}

.faq-icon {
  position: relative;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.faq-icon::before,
.faq-icon::after {
  content: '';
  position: absolute;
  background: var(--gold);
  border-radius: 2px;
  transition: transform 0.25s ease;
}

.faq-icon::before {
  top: 7px;
  left: 0;
  width: 16px;
  height: 2px;
}

.faq-icon::after {
  top: 0;
  left: 7px;
  width: 2px;
  height: 16px;
}

.faq-item.open .faq-icon::after {
  transform: scaleY(0);
}

.faq-a {
  max-height: 0;
  opacity: 0;
  transition: max-height 0.32s ease, opacity 0.32s ease;
}

.faq-item.open .faq-a {
  max-height: 260px;
  opacity: 1;
}

.faq-a p {
  padding: 0 24px 22px;
  font-size: 14.5px;
}

/* ---------------- 底部 CTA ---------------- */
.final-cta {
  text-align: center;
  padding: 56px 32px;
  box-shadow: var(--glow);
}

.final-cta h2 {
  font-size: clamp(24px, 3.2vw, 36px);
  font-weight: 800;
}

.final-cta p {
  margin: 12px 0 26px;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 158, 44, 0.5);
  }
  100% {
    box-shadow: 0 0 0 9px rgba(255, 158, 44, 0);
  }
}

/* ---------------- 响应式 ---------------- */
@media (max-width: 1024px) {
  .hero-grid {
    grid-template-columns: 1fr;
    gap: 36px;
  }
  .grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .flow {
    grid-template-columns: repeat(2, 1fr);
  }
  .calc {
    grid-template-columns: 1fr;
    gap: 34px;
    padding: 34px 30px;
  }
}

@media (max-width: 640px) {
  .section {
    padding: 46px 0;
  }
  .stat-strip {
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
  }
  .stat {
    border-right: none;
  }
  .stat:nth-child(odd) {
    border-right: 1px solid var(--border);
  }
  .grid,
  .flow,
  .quotes,
  .soon {
    grid-template-columns: 1fr;
  }
  .calc-split {
    gap: 28px;
  }
  .calc-num {
    font-size: 32px;
  }
  .cta .btn {
    width: 100%;
  }
}
</style>
